module.exports = __webpack_public_path__ + "static/media/logo.776fcfe5.png";